import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import block from 'bem-cn';

import SVG from 'components/SVG';

import formatNumber from 'shared/helpers/formatNumber';

import backIMG from './img/dashboard-card.svg';

import './DashboardCard.scss';

const b = block('dashboard-card-mobile');

const DashboardCard = () => {
  const locale = useSelector(state => state.locale.locale.dashboardLocale);
  const { currency } = useSelector(state => state.auth, shallowEqual);
  const { balance, incomeToday } = useSelector(
    state => state.statistic.general,
    shallowEqual,
  );

  const [balanceWhole, balanceFraction] = formatNumber(balance).split('.');
  const [incomeTodayWhole, incomeTodayFraction] = formatNumber(incomeToday).split('.');

  return (
    <section className={b()}>
      <div className={b('background')}>
        <SVG className={b('background-icon')} svgProps={{ svg: backIMG }} />
      </div>
      <div className={b('content')}>
        <div className={b('balance')}>
          <div className={b('balance-label')}>{locale.myBalance}</div>
          <span className={b('balance-value')}>{balanceWhole}</span>
          <span className={b('balance-currency')}>{`.${balanceFraction} ${currency}`}</span>
        </div>

        <div className={b('item')}>
          <div className={b('item-label')}>{locale.incomeForToday}</div>
          <span className={b('item-value')}>{incomeTodayWhole}</span>
          <span className={b('item-currency')}>{`.${incomeTodayFraction} ${currency}`}</span>
        </div>
      </div>
    </section>
  );
};

export default DashboardCard;
